import React from 'react';

const BlankPage = (props) => {
  return (
    <div
      style={{
        maxWidth: '100%',
        minHeight: '100vh',
        padding: '0',
        margin: 'auto'
      }}
      {...props}
    />
  );
};

export default BlankPage;